<script setup>
/**
 * FormControlMBasketOrdersQuantity
 * Structural utility component. Renders no UI elements.
 * Automatically modifies the orchestrator field schema to enforce immediate layout hiding.
 */
import { onMounted } from 'vue';

const props = defineProps({
    // Standard Orchestrator Props
    field: {
        type: Object,
        required: true
    },
    formId: {
        type: String,
        default: ''
    },
    currentData: {
        type: Object,
        default: () => ({})
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
});

// --- Lifecycle ---

onMounted(() => {
    /**
     * Enforce immediate field configuration hiding on component insertion.
     * Replaces the legacy Options API created() hook safely for the Vite transition.
     */
    if (props.field) {
        props.field.hidden = true;
    }
});
</script>

<template>

</template>

<style scoped>
/* No structural styling rules required */
</style>